import React from 'react';
import { howItWorks } from '../data/mock';
import { Package, Truck, CheckCircle, ArrowRight } from 'lucide-react';

const iconMap = {
  Package: Package,
  Truck: Truck,
  CheckCircle: CheckCircle
};

const HowItWorks = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold tracking-wider uppercase text-sm">Simple Process</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1a365d] mt-4 mb-6">
            Three Steps to a <span className="text-blue-500">Cleaner Space</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            No complicated paperwork. No surprise fees. Just straightforward bin rental that works.
          </p>
        </div>

        {/* Steps - Horizontal Timeline Layout */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden md:block absolute top-24 left-[15%] right-[15%] h-1 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200 rounded-full"></div>
          
          <div className="grid md:grid-cols-3 gap-8 relative">
            {howItWorks.map((step, index) => {
              const IconComponent = iconMap[step.icon];
              return (
                <div key={step.step} className="relative">
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group">
                    {/* Step Circle */}
                    <div className="relative mb-6">
                      <div className="w-20 h-20 mx-auto bg-gradient-to-br from-[#1a365d] to-blue-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                        <IconComponent className="h-10 w-10 text-white" />
                      </div>
                      {/* Step Number Badge */}
                      <div className="absolute -top-2 -right-2 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md">
                        {step.step}
                      </div>
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-bold text-[#1a365d] mb-3 text-center">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-center leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Arrow (between cards) */}
                  {index < howItWorks.length - 1 && (
                    <div className="hidden md:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                      <ArrowRight className="h-8 w-8 text-blue-300" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-4 bg-[#1a365d] rounded-full px-8 py-4">
            <span className="text-white font-medium">Ready to get started?</span>
            <button 
              onClick={() => {
                const element = document.querySelector('#bins');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-[#1a365d] font-semibold px-6 py-2 rounded-full hover:bg-blue-50 transition-colors"
            >
              Choose Your Bin
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
